import { useQuery } from "@tanstack/react-query";
import { fetchWadaPatras } from "../services/wadaPatraServices";

export const useFetchWadapatra = (id) => useQuery({
    queryKey: ['wadapatra', id],
    queryFn: () => fetchWadaPatras(id)
})
